/**
 * What a complete profile means.
 *
 * Eight fields: first name, last name, phone, email, gender, home club, BSA
 * number and date of birth. Email is special: it comes from the login identity
 * (Kinde), is read-only in the UI, and profiles provisioned before the email
 * column existed may have NULL in the database - the Kinde email still counts.
 */

export const REQUIRED_FIELDS = [
  "first_name",
  "last_name",
  "phone_number",
  "email",
  "gender",
  "home_club_id",
  "bsa_number",
  "date_of_birth",
];

export const GENDERS = ["Male", "Female"];

function isFilled(field, profile, kindeUser) {
  if (field === "email") {
    return Boolean(profile?.email || kindeUser?.email);
  }

  const value = profile?.[field];

  if (value === null || value === undefined) return false;

  // home_club_id is a number, not a string.
  if (field === "home_club_id") return Number(value) > 0;

  return String(value).trim() !== "";
}

/**
 * @param {object|null} profile - the user_profiles row from Redux
 * @param {object|null} kindeUser - the Kinde user object (for the email)
 * @returns {{filled: string[], missing: string[], pct: number, complete: boolean}}
 */
export function getProfileCompletion(profile, kindeUser = null) {
  const filled = REQUIRED_FIELDS.filter((field) =>
    isFilled(field, profile, kindeUser),
  );
  const missing = REQUIRED_FIELDS.filter(
    (field) => !isFilled(field, profile, kindeUser),
  );

  return {
    filled,
    missing,
    pct: Math.round((filled.length / REQUIRED_FIELDS.length) * 100),
    complete: missing.length === 0,
  };
}
